import { render, staticRenderFns } from "./FooterNavigation.vue?vue&type=template&id=e87a2290&scoped=true&"
import script from "./FooterNavigation.vue?vue&type=script&lang=js&"
export * from "./FooterNavigation.vue?vue&type=script&lang=js&"
import style0 from "./FooterNavigation.vue?vue&type=style&index=0&id=e87a2290&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87a2290",
  null
  
)

export default component.exports